import { send2FCode } from "@/Services/TherapyApi/Auth";

import type { AuthResponse } from "@/Modules/Models/Domain/Auth";
import { LocalStorageNamespace } from "@/Modules/App/Models/Localstorage/LocalStorageNamespace";
import { LocalStorageKey } from "@/Modules/App/Models/Localstorage/LocalStorageKey";

import { LocalStorageService } from "@/Services/LocalStorageService";
import useAuthStore from "../Store";

import { isValidString } from "@/Utils/String";
import { hasValue } from "@/Utils/Objects";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

export interface Send2FactorCodeProps {
  hashCode: string;
  code: string;
}

async function send2FactorCode(props: Send2FactorCodeProps): Promise<AuthResponse | undefined> {
  const authStore = useAuthStore();

  const response = await send2FCode({ hash_2F: props.hashCode, code: props.code }).catch(() => undefined);

  if (!hasValue(response) || isApiError(response)) {
    return undefined;
  }

  if (isValidString(response.token)) {
    authStore.userToken = response.token;

    saveTokenInLocalStorage(response.token);

    return {
      token: response.token,
    };
  }

  return {
    hash2F: response.hash_2F!,
  };
}

function saveTokenInLocalStorage(token: string) {
  const authLocalStorageService: LocalStorageService = new LocalStorageService(LocalStorageNamespace.AUTH);
  const LOCAL_STORAGE_AUTH_TOKEN_KEY: string = LocalStorageKey.USER_TOKEN;

  authLocalStorageService.set(LOCAL_STORAGE_AUTH_TOKEN_KEY, token);
}

export default send2FactorCode;
